<template>
  <div id="app">
    <Header/> 
    <LeftSideBar />
    <router-view/>
    <Footer />
    <notifications group="foo" />
  </div>
</template>
<script>
import Header from './components/layout/Header/Header';
import Footer from './components/layout/Footer';
import LeftSideBar from './components/layout/LeftSideBar/LeftSideBar';
export default {
  name: "app",
  components: {
    Header,
    LeftSideBar,
    Footer
  },
  created() {
    if (this.$workbox) {
      this.$workbox.addEventListener("waiting", () => {
        this.showUpgradeUI = true;
      });
    }
  },
  methods: {
    async accept() {
      this.showUpgradeUI = false
      await this.$workbox.messageSW({ type: "SKIP_WAITING" });
    }
  },
}
</script>
